export default __webpack_public_path__ + "static/media/267.11da9a3e.png";